import { Link } from "react-router-dom";
import { useAuth } from "../AuthContext";
import { useForm } from "react-hook-form";
import { StarIcon } from "@heroicons/react/20/solid";
import OnboardingTestimonialCard from "../components/OnboardingTestimonialCard";
import React from "react";
import SignupOnboardingWrapper from "../components/SignupOnboardingWrapper";
import PrimaryButton from "../components/PrimaryButton";
import SecondaryButton from "../components/SecondaryButton";
import Input from "../components/Input";

const LOGIN_HREF = "/onboarding/signin";

export default function Signup() {
  const { signUpWithEmail, signInWithGoogle, errors, loading } = useAuth();

  const { register, handleSubmit } = useForm({
    defaultValues: {
      email: "",
      password: "",
    },
  });

  const submit = async input => {
    if (loading) return null;
    const { email, password } = input;
    signUpWithEmail(email, password);
  };

  return (
    <SignupOnboardingWrapper>
      <div className="block sm:grid grid-cols-1 relative lg:grid-cols-2 w-full">
        <div className="flex items-center justify-center">
          <div className="w-full px-4 sm:px-0 sm:max-w-sm">
            <div className="text-center sm:text-left">
              <h2 className="mt-8 text-2xl/9 font-bold tracking-tight text-gray-900">
                Get started for free
              </h2>
              <p className="mt-2 text-sm/6 text-gray-500">
                No commitments. No card required.
              </p>
            </div>

            <div className="mt-6 sm:mt-10">
              <div>
                <form onSubmit={handleSubmit(submit)} className="space-y-6">
                  <div>
                    <label
                      htmlFor="email"
                      className="block text-sm/6 font-medium text-gray-900"
                    >
                      Email
                    </label>
                    <div className="mt-2">
                      <Input
                        name="email"
                        type="email"
                        autoComplete="email"
                        placeholder="Enter your email"
                        register={register}
                      />
                    </div>
                  </div>

                  <div>
                    <label
                      htmlFor="password"
                      className="block text-sm/6 font-medium text-gray-900"
                    >
                      Password
                    </label>
                    <div className="mt-2">
                      <Input
                        name="password"
                        type="password"
                        autoComplete="password"
                        placeholder="Enter your password"
                        register={register}
                        error={errors[0]}
                      />
                    </div>
                  </div>

                  <PrimaryButton loading={loading}>
                    {loading ? "Get Started..." : "Get Started"}
                  </PrimaryButton>
                </form>
              </div>

              <div className="mt-6">
                <SecondaryButton
                  onClick={signInWithGoogle}
                  type="button"
                  startIcon={
                    <svg
                      viewBox="0 0 24 24"
                      aria-hidden="true"
                      className="h-5 w-5"
                    >
                      <path
                        d="M12.0003 4.75C13.7703 4.75 15.3553 5.36002 16.6053 6.54998L20.0303 3.125C17.9502 1.19 15.2353 0 12.0003 0C7.31028 0 3.25527 2.69 1.28027 6.60998L5.27028 9.70498C6.21525 6.86002 8.87028 4.75 12.0003 4.75Z"
                        fill="#EA4335"
                      />
                      <path
                        d="M23.49 12.275C23.49 11.49 23.415 10.73 23.3 10H12V14.51H18.47C18.18 15.99 17.34 17.25 16.08 18.1L19.945 21.1C22.2 19.01 23.49 15.92 23.49 12.275Z"
                        fill="#4285F4"
                      />
                      <path
                        d="M5.26498 14.2949C5.02498 13.5699 4.88501 12.7999 4.88501 11.9999C4.88501 11.1999 5.01998 10.4299 5.26498 9.7049L1.275 6.60986C0.46 8.22986 0 10.0599 0 11.9999C0 13.9399 0.46 15.7699 1.28 17.3899L5.26498 14.2949Z"
                        fill="#FBBC05"
                      />
                      <path
                        d="M12.0004 24.0001C15.2404 24.0001 17.9654 22.935 19.9454 21.095L16.0804 18.095C15.0054 18.82 13.6204 19.245 12.0004 19.245C8.8704 19.245 6.21537 17.135 5.2654 14.29L1.27539 17.385C3.25539 21.31 7.3104 24.0001 12.0004 24.0001Z"
                        fill="#34A853"
                      />
                    </svg>
                  }
                >
                  Sign up with Google
                </SecondaryButton>
              </div>

              <p className="mt-6 sm:mt-10 text-center text-sm/6 text-gray-500">
                Already have an account?{" "}
                <Link
                  to={LOGIN_HREF}
                  className="font-semibold text-primary hover:text-primary"
                >
                  Log in
                </Link>
              </p>

              <div className="mt-6 sm:mt-10 flex items-center gap-6 justify-center">
                <div className="flex -space-x-2">
                  <img
                    alt=""
                    src="https://images.unsplash.com/photo-1491528323818-fdd1faba62cc?ixlib=rb-1.2.1&ixid=eyJhcHBfaWQiOjEyMDd9&auto=format&fit=facearea&facepad=2&w=256&h=256&q=80"
                    className="inline-block size-10 rounded-full ring-2 ring-white"
                  />
                  <img
                    alt=""
                    src="https://images.unsplash.com/photo-1519244703995-f4e0f30006d5?ixlib=rb-1.2.1&ixqx=oilqXxSqey&ixid=eyJhcHBfaWQiOjEyMDd9&auto=format&fit=facearea&facepad=2&w=256&h=256&q=80"
                    className="inline-block size-10 rounded-full ring-2 ring-white"
                  />
                  <img
                    alt=""
                    src="https://images.unsplash.com/photo-1520785643438-5bf77931f493?ixlib=rb-=eyJhcHBfaWQiOjEyMDd9&auto=format&fit=facearea&facepad=2.5&w=256&h=256&q=80"
                    className="inline-block size-10 rounded-full ring-2 ring-white"
                  />
                  <img
                    alt=""
                    src="https://images.unsplash.com/photo-1531427186611-ecfd6d936c79?ixlib=rb-=eyJhcHBfaWQiOjEyMDd9&auto=format&fit=facearea&facepad=2&w=256&h=256&q=80"
                    className="inline-block size-10 rounded-full ring-2 ring-white"
                  />
                  <img
                    alt=""
                    src="https://images.unsplash.com/photo-1500648767791-00dcc994a43e?ixlib=rb-=eyJhcHBfaWQiOjEyMDd9&auto=format&fit=facearea&facepad=8&w=256&h=256&q=80"
                    className="inline-block size-10 rounded-full ring-2 ring-white"
                  />
                </div>

                <div className="flex flex-col gap-2 items-center font-semibold text-sm">
                  <div className="flex items-center gap-2">
                    <div className="flex gap-1">
                      <StarIcon
                        aria-hidden="true"
                        className="text-yellow-400 size-5 shrink-0"
                      />
                      <StarIcon
                        aria-hidden="true"
                        className="text-yellow-400 size-5 shrink-0"
                      />
                      <StarIcon
                        aria-hidden="true"
                        className="text-yellow-400 size-5 shrink-0"
                      />
                      <StarIcon
                        aria-hidden="true"
                        className="text-yellow-400 size-5 shrink-0"
                      />
                      <StarIcon
                        aria-hidden="true"
                        className="text-yellow-400 size-5 shrink-0"
                      />
                    </div>
                    <span>5.0</span>
                  </div>
                  <span>from 200+ reviews</span>
                </div>
              </div>
            </div>
          </div>
        </div>
        <div className="relative hidden lg:block">
          <img
            alt="background"
            src="/signup/bg.jpg"
            className="absolute inset-0 size-full object-cover"
          />

          <div className="absolute bottom-0 w-full p-8 ">
            <div className="w-full max-w-3xl m-auto">
              <OnboardingTestimonialCard />
            </div>
          </div>
        </div>
      </div>
    </SignupOnboardingWrapper>
  );
}
